import React from "react"

const IconSlides = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <title>Slides</title>
    <rect x="3" y="4" width="18" height="14" rx="2" ry="2"></rect>
    <polygon
      points="10,9 16,12 10,15"
      fill="currentColor"
      stroke="none"
    ></polygon>
  </svg>
)

export default IconSlides
